(function(){
  function selectTab(root, id){
    if(!root || !id) return;
    const idValue = id.startsWith('#') ? id.slice(1) : id;
    const list = root.querySelector('.tabs');
    const links = Array.from(list ? list.querySelectorAll('.tab__button') : []);
    const panels = Array.from(root.querySelectorAll('.drawer-tab-panel'));
    panels.forEach(p => p.hidden = true);
    links.forEach(a => a.setAttribute('aria-selected','false'));
    const target = panels.find(p => p.id === idValue);
    if(target){
      target.hidden = false;
    }
    const link = links.find(a => a.getAttribute('href') === '#' + idValue);
    if(link){
      link.setAttribute('aria-selected','true');
      
      // Scroll the selected tab into view
      const tabSlide = link.closest('.slider__slide');
      if(tabSlide && list){
        const targetScrollLeft = tabSlide.offsetLeft;
        const currentScrollLeft = list.scrollLeft;
        
        // Only scroll if we need to move to a different position
        if(Math.abs(targetScrollLeft - currentScrollLeft) > 5){
          list.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
          });
        }
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.addEventListener('click', function(e){
      const btn = e.target.closest('[data-open-tab]');
      if(!btn) return;
      const controls = btn.getAttribute('aria-controls');
      const tabId = btn.getAttribute('data-open-tab');
      if(!controls || !tabId) return;
      const drawer = document.getElementById(controls);
      if(!drawer) return;
      const container = drawer.querySelector('.menu-drawer__inner-container');
      if(container){
        // After the drawer opens, select the requested tab
        setTimeout(function(){ selectTab(container, tabId); }, 50);
      }
    });
    document.addEventListener('click', function(e){
      const a = e.target.closest('a.tab__button');
      if(!a) return;
      const container = a.closest('.menu-drawer__inner-container');
      if(!container) return;
      const href = a.getAttribute('href');
      if(href && href.startsWith('#')){
        e.preventDefault();
        selectTab(container, href);
      }
    });
  });
})();
